import script from "./DealCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DealCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./DealCarousel.vue?vue&type=style&index=0&id=68a9db7b&lang=scss"

const __exports__ = script;

export default __exports__